import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const RESERVATION_LIST_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/reservation-list`;
